/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Noaccess3Inputs */

const en_coinvestments_dataroom_noaccess3 = /** @type {(inputs: Coinvestments_Dataroom_Noaccess3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No access`)
};

/**
* | output |
* | --- |
* | "No access" |
*
* @param {Coinvestments_Dataroom_Noaccess3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_noaccess3 = /** @type {((inputs?: Coinvestments_Dataroom_Noaccess3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Noaccess3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_noaccess3(inputs)
});
export { coinvestments_dataroom_noaccess3 as "coInvestments_dataRoom_noAccess" }